import React, { Component } from 'react';
import './ProductComponents.css';
import { ProductComponent } from './ProductComponent';

export default class ProductComponents extends Component {
  render() {
    return (
      <div className="prodcomponents">
	      <div className="container">
	      	<div className="row row-centered">
	          {this.renderComponents()}
	        </div>
	      </div>
      </div>
    );
  }

  renderComponents() {
  	return this.props.Components.map((c, i) => {
  		return (
  			<ProductComponent key={`pc_${i}`} {...c} /> 
  		);
  	});
  }
}


export { ProductComponents };



/** WEBPACK FOOTER **
 ** ./src/common/ProductComponents.js
 **/